'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestData(description, additionalNotes, createdAt) {
  this.Lapp_api_DrugRequestData__f_description = null;
  this.Lapp_api_DrugRequestData__f_additionalNotes = null;
  this.Lapp_api_DrugRequestData__f_createdAt = null;
  this.Lapp_api_DrugRequestData__f_description = description;
  this.Lapp_api_DrugRequestData__f_additionalNotes = additionalNotes;
  this.Lapp_api_DrugRequestData__f_createdAt = createdAt;
}
export { $c_Lapp_api_DrugRequestData as $c_Lapp_api_DrugRequestData };
$c_Lapp_api_DrugRequestData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestData.prototype.constructor = $c_Lapp_api_DrugRequestData;
/** @constructor */
function $h_Lapp_api_DrugRequestData() {
}
export { $h_Lapp_api_DrugRequestData as $h_Lapp_api_DrugRequestData };
$h_Lapp_api_DrugRequestData.prototype = $c_Lapp_api_DrugRequestData.prototype;
$c_Lapp_api_DrugRequestData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestData.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1612750830), true);
});
$c_Lapp_api_DrugRequestData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestData)) {
    var x = this.Lapp_api_DrugRequestData__f_description;
    var x$2 = x$0.Lapp_api_DrugRequestData__f_description;
    if ((((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)) && (this.Lapp_api_DrugRequestData__f_additionalNotes === x$0.Lapp_api_DrugRequestData__f_additionalNotes))) {
      var x$3 = this.Lapp_api_DrugRequestData__f_createdAt;
      var x$4 = x$0.Lapp_api_DrugRequestData__f_createdAt;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestData.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_api_DrugRequestData.prototype.productPrefix__T = (function() {
  return "DrugRequestData";
});
$c_Lapp_api_DrugRequestData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_api_DrugRequestData__f_description;
      break;
    }
    case 1: {
      return this.Lapp_api_DrugRequestData__f_additionalNotes;
      break;
    }
    case 2: {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(this.Lapp_api_DrugRequestData__f_createdAt);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_DrugRequestData.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "description";
      break;
    }
    case 1: {
      return "additionalNotes";
      break;
    }
    case 2: {
      return "createdAt";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DrugRequestData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestData)));
}
export { $isArrayOf_Lapp_api_DrugRequestData as $isArrayOf_Lapp_api_DrugRequestData };
var $d_Lapp_api_DrugRequestData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestData, "app.api.DrugRequestData", ({
  Lapp_api_DrugRequestData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestData as $d_Lapp_api_DrugRequestData };
//# sourceMappingURL=app.api.-Drug-Request-Data.js.map
